var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4209 5.42038C5.4209 5.13083 5.49987 4.84748 5.65161 4.59973C5.8018 4.35199 6.01703 4.1507 6.27561 4.01754C6.53264 3.88438 6.82219 3.82399 7.11019 3.84412C7.39974 3.86425 7.6769 3.96335 7.9138 4.13057C8.1507 4.2978 8.33651 4.52696 8.45109 4.79173C8.56567 5.05806 8.60593 5.34915 8.56567 5.63715C8.52541 5.9236 8.40774 6.19457 8.22503 6.41909C8.04232 6.6436 7.80077 6.81238 7.52825 6.90993C7.37496 6.96412 7.24025 7.06477 7.1458 7.19793C7.05135 7.33109 7.00025 7.49057 7.00025 7.6547V8.18425",
    stroke: "#026CE3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99976 10.1587C6.89148 10.1587 6.80176 10.0705 6.80176 9.9607C6.80176 9.85087 6.88993 9.7627 6.99976 9.7627",
    stroke: "#026CE3",
    strokeWidth: 1.25,
    strokeMiterlimit: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.1587C7.10828 10.1587 7.198 10.0705 7.198 9.9607C7.198 9.85087 7.10983 9.7627 7 9.7627",
    stroke: "#026CE3",
    strokeWidth: 1.25,
    strokeMiterlimit: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C10.3135 13 13 10.3135 13 7C13 3.68645 10.3135 1 7 1C3.68645 1 1 3.68645 1 7C1 10.3135 3.68645 13 7 13Z",
    stroke: "#026CE3",
    strokeWidth: 1.25,
    strokeMiterlimit: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.418caa2c517b0cc9b3afda9ea4690654.svg";
export { ForwardRef as ReactComponent };